import type { FocusEvent, KeyboardEvent } from "react";

import { MkField } from "./MkField";

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

interface Props {
    value?: string | false;
    fallback?: string;
    label?: string;
    hint?: string;
    error?: string;
    disabled?: boolean;
    className?: string;
    onUpdate?(value: string): void;
}

export function MkColorInput({ value = "", fallback = "#3b82f6", label, hint, error, disabled,
                               className, onUpdate }: Props) {
    const raw = String(value || "").trim();
    const hex = HEX_RE.test(raw) ? raw.toLowerCase() : fallback;
    const text = String(value || "");

    function commit(event: FocusEvent<HTMLInputElement> | KeyboardEvent<HTMLInputElement>) {
        const typed = event.currentTarget.value.trim();
        if (typed === text) {
            return;
        }
        onUpdate?.(typed.startsWith("#") || !typed ? typed : `#${typed}`);
    }

    return (
        <MkField label={label} hint={hint} error={error} className={className}>
            <div className="mk-color-wrap">
                <input type="color" className="mk-color-swatch" value={hex} disabled={disabled}
                       onChange={(event) => onUpdate?.(event.target.value)} />
                <input type="text" className="mk-color-hex" defaultValue={text} key={text}
                       spellCheck={false} disabled={disabled} onBlur={commit}
                       onKeyDown={(event) => {
                           if (event.key === "Enter") {
                               commit(event);
                           }
                       }} />
            </div>
        </MkField>
    );
}
